import { useCustomModal } from 'src/hooks'
import { ClaimAccountButton } from './claim-account-button'
import { ClaimAccountModal } from './claim-account-modal'

export const ClaimAccount = () => {
  const { handleClose, handleOpen, open } = useCustomModal()

  const habdleClick = () => {
    handleOpen()
  }

  return (
    <>
      <ClaimAccountButton onClick={habdleClick} />
      <ClaimAccountModal open={open} handleClose={handleClose} />
    </>
  )
}
